import { StatusBadge } from "@components";
import { resolveInfractionDisplayStatusBadgeStyles } from "../constants/infraction-status-badge.constant";

export type InfractionStatusBadgeProps = {
	displayStatus: number;
	label: string;
	className?: string;
};

export function InfractionStatusBadge({
	displayStatus,
	label,
	className,
}: InfractionStatusBadgeProps) {
	return (
		<StatusBadge
			className={className}
			data-slot="infraction-status-badge"
			label={label}
			palette={resolveInfractionDisplayStatusBadgeStyles(displayStatus)}
		/>
	);
}
